import React from "react";
import QuoteInfo from "components/QuoteInfo.js";
import {getRequests, postRequest} from "../helpers/ApiHelper";
import {withRouter} from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";

class Passenger extends React.Component {
    quote = {};
    fleet = {};
    maxPassenger = 11;
    maxLuggage = 20;
    startAddressType = '';
    payment_type = '';
    quoteLoading = true;
    quoteFleetLoading = true;
    state = {
        quote: {},
        fleet: {},
        extra: {
            passenger_name: '',
            passenger_email: '',
            passenger_mobile: '',
            pickup_address_line: '',
            dropoff_address_line: '',
            special_instruction: '',
            passenger_count: '',
            child_seat_count: 0,
            infant_seat_count: 0,
            booster_seat_count: 0,
            luggage_count: '',
            waiting_time: '',
            message_board: '',
            arrival_time: '',
            airline_name: '',
            flight_number: '',
            payment_type: '',
            return_airline_name: '',
            return_flight_number: '',
            return_arrival_time: '',

        },
        extraRate: {},
        quoteLoading: true,
        startDate: null,
        startTime: null,
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleQuoteChange = this.handleQuoteChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
    }

    handleQuoteChange(data, type = "address") {
        const state = this.state;
        switch (type) {
            case "time":
                state.startTime = data;
                state.quote.return_pickup_time = moment(data).format("HH:mm");
                break;
            case "date":
                state.startDate = data;
                state.quote.return_pickup_date = moment(data).format("YYYY-MM-DD");
                break;
            default:
        }

        this.setState(state);
    }

    handleDateChange(date) {
        this.handleQuoteChange(date, "date");
    }

    handleTimeChange(date) {
        this.handleQuoteChange(date, "time");
    }

    componentDidMount() {
        const quoteId = localStorage.getItem('quoteId');
        const quoteFleetId = localStorage.getItem('quoteFleetId');
        const startAddressType = localStorage.getItem('airportLocation');
        const quoteExtra = localStorage.getItem('quoteExtra');

        if (quoteId !== undefined && quoteFleetId !== undefined) {
            getRequests('quote/' + quoteId).then(data => {
                getRequests('quote-fleet/' + quoteFleetId).then(fleetData => {
                    this.quoteFleetLoading = false;
                    this.startAddressType = startAddressType;
                    this.quote = data;
                    const quote = data;
                    this.fleet = fleetData;
                    let extra = this.state.extra;
                   // console.log(JSON.parse(quoteExtra), this.state.extra);
                    if (quoteExtra !== undefined && quoteExtra !== null) {
                        extra = JSON.parse(quoteExtra);
                        if(extra !== undefined && extra !== null) {
                            extra.arrival_time_full = (extra && extra.arrival_time_full !== undefined && extra.arrival_time_full !== null) ? new Date(extra.arrival_time_full) : undefined;
                            extra.return_arrival_time_full = (extra && extra.return_arrival_time_full !== undefined && extra.return_arrival_time_full !== null) ? new Date(extra.return_arrival_time_full) : undefined;

                            extra.child_seat_count = 0;
                            extra.infant_seat_count = 0;
                            extra.booster_seat_count = 0;
                        }
                    }
                    extra.passenger_count = data.no_of_passengers;
                    extra.luggage_count = data.no_of_luggage;
                    this.setState({
                        extra: extra,
                        quote: quote,
                        quoteLoading: false,
                    });
                    getRequests('extra-rate/' + quoteFleetId).then(extraData => {
                        this.setState({
                            extraRate: extraData
                        });
                    });
                });
            });
        }
    }

    arraySum(items, prop) {
        return items.reduce(function (a, b) {
            return a + b[prop];
        }, 0);
    }

    handleChange(changeObject) {
        this.setState(changeObject)
    }

    handleInputChange(type, event, value = null) {
        const extra = this.state.extra;
        if(type === 'arrival_time' || type === 'return_arrival_time'){
            extra[type] = moment(event).format("hh:mm a");
            extra[type+ '_full'] =event;
        }else{
            extra[type] =  value !== null  ? value : event.target.value;
        }
        if (type === 'child_seat_count') {
            if (this.state.extraRate.child_seat_charge > 0) {
                this.fleet.fare_data.additional.charges.forEach((charge) => {
                    if (charge.ref === 'child_seat_charge') {
                        charge.value = event.target.value * this.state.extraRate.child_seat_charge;
                    }
                });
                this.fleet.fare_data.additional.charges.forEach((charge) => {
                    if (charge.ref === 'merchant_fee') {
                        const total = this.fleet.fare_data.fare + (this.arraySum(this.fleet.fare_data.additional.charges, 'value')- charge.value);
                            charge.value =  parseFloat((total*(charge.data ? charge.data : 0.04)).toFixed(2));
                    }
                });
                this.fleet.fare_data.one_way_total = this.fleet.fare_data.fare + this.arraySum(this.fleet.fare_data.additional.charges, 'value');
                if(this.state.quote.trip_type === "round_trip"){

                    this.fleet.fare_data.return_additional.charges.forEach((charge) => {
                        if (charge.ref === 'child_seat_charge') {
                            charge.value = event.target.value * this.state.extraRate.child_seat_charge;
                        }
                    });
                    this.fleet.fare_data.return_additional.charges.forEach((charge) => {
                        if (charge.ref === 'merchant_fee') {
                            const total = this.fleet.fare_data.return_fare + (this.arraySum(this.fleet.fare_data.return_additional.charges, 'value')- charge.value);
                            charge.value =  parseFloat((total*(charge.data ? charge.data : 0.04)).toFixed(2));
                        }
                    });
                    this.fleet.fare_data.return_total = this.fleet.fare_data.return_fare + this.arraySum(this.fleet.fare_data.return_additional.charges, 'value');
                }

            }

            this.setState({
                fleet: this.fleet,
                quoteLoading: true

            });
            setTimeout(() => {
                this.setState({
                    quoteLoading: false
                });
            }, 200);
        }
        if (type === 'infant_seat_count') {
            if (this.state.extraRate.infant_seat_charge > 0) {
                this.fleet.fare_data.additional.charges.forEach((charge) => {
                    if (charge.ref === 'infant_seat_charge') {
                        charge.value = event.target.value * this.state.extraRate.infant_seat_charge;
                    }
                });
                this.fleet.fare_data.additional.charges.forEach((charge) => {
                    if (charge.ref === 'merchant_fee') {
                        const total = this.fleet.fare_data.fare + (this.arraySum(this.fleet.fare_data.additional.charges, 'value')- charge.value);
                            charge.value =  parseFloat((total*(charge.data ? charge.data : 0.04)).toFixed(2));
                    }
                });
                this.fleet.fare_data.one_way_total = this.fleet.fare_data.fare + this.arraySum(this.fleet.fare_data.additional.charges, 'value');
                if(this.state.quote.trip_type === "round_trip"){

                    this.fleet.fare_data.return_additional.charges.forEach((charge) => {
                        if (charge.ref === 'infant_seat_charge') {
                            charge.value = event.target.value * this.state.extraRate.infant_seat_charge;
                        }
                    });
                    this.fleet.fare_data.return_additional.charges.forEach((charge) => {
                        if (charge.ref === 'merchant_fee') {
                            const total = this.fleet.fare_data.return_fare + (this.arraySum(this.fleet.fare_data.return_additional.charges, 'value')- charge.value);
                            charge.value =  parseFloat((total*(charge.data ? charge.data : 0.04)).toFixed(2));
                        }
                    });
                    this.fleet.fare_data.return_total = this.fleet.fare_data.return_fare + this.arraySum(this.fleet.fare_data.return_additional.charges, 'value');
                }

            }

            this.setState({
                fleet: this.fleet,
                quoteLoading: true

            });
            setTimeout(() => {
                this.setState({
                    quoteLoading: false
                });
            }, 200);
        }
        if (type === 'booster_seat_count') {
            if (this.state.extraRate.booster_seat_charge > 0) {
                this.fleet.fare_data.additional.charges.forEach((charge) => {
                    if (charge.ref === 'booster_seat_charge') {
                        charge.value = event.target.value * this.state.extraRate.booster_seat_charge;
                    }
                });
                this.fleet.fare_data.additional.charges.forEach((charge) => {
                    if (charge.ref === 'merchant_fee') {
                        const total = this.fleet.fare_data.fare + (this.arraySum(this.fleet.fare_data.additional.charges, 'value')- charge.value);
                            charge.value =  parseFloat((total*(charge.data ? charge.data : 0.04)).toFixed(2));
                    }
                });
                this.fleet.fare_data.one_way_total = this.fleet.fare_data.fare + this.arraySum(this.fleet.fare_data.additional.charges, 'value');
                if(this.state.quote.trip_type === "round_trip"){

                    this.fleet.fare_data.return_additional.charges.forEach((charge) => {
                        if (charge.ref === 'booster_seat_charge') {
                            charge.value = event.target.value * this.state.extraRate.booster_seat_charge;
                        }
                    });
                    this.fleet.fare_data.return_additional.charges.forEach((charge) => {
                        if (charge.ref === 'merchant_fee') {
                            const total = this.fleet.fare_data.return_fare + (this.arraySum(this.fleet.fare_data.return_additional.charges, 'value')- charge.value);
                            charge.value =  parseFloat((total*(charge.data ? charge.data : 0.04)).toFixed(2));
                        }
                    });
                    this.fleet.fare_data.return_total = this.fleet.fare_data.return_fare + this.arraySum(this.fleet.fare_data.return_additional.charges, 'value');
                }

            }

            this.setState({
                fleet: this.fleet,
                quoteLoading: true

            });
            setTimeout(() => {
                this.setState({
                    quoteLoading: false
                });
            }, 200);
        }

        this.setState({
            extra: extra
        });
    }

    fleetSelected() {
        // this.props.history.push("/first");
    }

    onFormSubmit(e) {
        e.preventDefault();
        if (true) {
            localStorage.setItem('quoteExtra', JSON.stringify(this.state.extra));
            const total = (this.state.quote.trip_type === "round_trip" ? (this.fleet.fare_data.one_way_total + this.fleet.fare_data.return_total) : this.fleet.fare_data.one_way_total);
            const data = {
                fare_data: this.fleet.fare_data,
                total: total
            };
            if (this.quote.trip_type === 'round_trip') {
                data.return_date = this.state.quote.return_pickup_date;
                data.return_time = this.state.quote.return_pickup_time;
            }
            postRequest('quote-fleet-update/' + this.fleet.id, data).then(res => {
                this.props.history.push("/book-confirm");
            }, error => {

            });

        }

    }

    render() {

        return (
            <section className="booking-flow-wrapper section-gap  ">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="booking-sidebar-wrapper">
                                <h4>Booking Information</h4>
                                {this.state.quoteLoading &&

                                <div className="loader-wrapper">
                                    <div className="  loader">
                                        <span>L</span>
                                        <span>o</span>
                                        <span>a</span>
                                        <span>d</span>
                                        <span>i</span>
                                        <span>n</span>
                                        <span>g</span>
                                    </div>
                                </div>

                                }
                                {!this.state.quoteLoading &&

                                <QuoteInfo quoteData={this.quote} fleetData={this.fleet}/>

                                }

                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="booking-form-wrapper">
                                <form onSubmit={this.onFormSubmit}>
                                    <h4>Personal Information</h4>
                                    <div className="row no-gutter">
                                        <div className="col-md-4">
                                            <label htmlFor="name">Full Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                value={this.state.extra.passenger_name}
                                                onChange={(e) => {
                                                    this.handleInputChange('passenger_name', e)
                                                }}
                                                placeholder="Enter Full Name"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="email">Email Address</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                value={this.state.extra.passenger_email}
                                                onChange={(e) => {
                                                    this.handleInputChange('passenger_email', e)
                                                }}
                                                placeholder="Enter Email Address"
                                                required
                                                style={{
                                                    height: "50px",
                                                    borderRadius: 0
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="phone">Phone Number</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="phone"
                                                value={this.state.extra.passenger_mobile}
                                                onChange={(e) => {
                                                    this.handleInputChange('passenger_mobile', e)
                                                }}
                                                placeholder="Enter Phone Number"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <h4>Travel Details</h4>
                                    <div className="row no-gutter">
                                        <div className="col-md-3">
                                            <label htmlFor="pax">No. of Passenger</label>
                                            <select className="form-control" id="pax" onChange={(e) => {
                                                this.handleInputChange('passenger_count', e)
                                            }} value={this.state.extra.passenger_count}>
                                                {[...Array(this.maxPassenger).keys()].map(
                                                    (number, key) => {
                                                        return (
                                                            <option key={key} value={number + 1}>
                                                                {number + 1}
                                                            </option>
                                                        );
                                                    }
                                                )}
                                            </select>
                                        </div>

                                        <div className="col-md-3">
                                            <label htmlFor="pax">No. of Luggage</label>
                                            <select className="form-control" id="pax" onChange={(e) => {
                                                this.handleInputChange('luggage_count', e)
                                            }} value={this.state.extra.luggage_count}>
                                                {[...Array(this.maxLuggage).keys()].map(
                                                    (number, key) => {
                                                        return (
                                                            <option key={key} value={number + 1}>
                                                                {number + 1}
                                                            </option>
                                                        );
                                                    }
                                                )}
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="pax">Toddler Seat</label>
                                            <select className="form-control" id="pax" onChange={(e) => {
                                                this.handleInputChange('child_seat_count', e)
                                            }} value={this.state.extra.child_seat_count}>
                                                <option value="0">0</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="pax">Infant Seat</label>
                                            <select className="form-control" id="pax" onChange={(e) => {
                                                this.handleInputChange('infant_seat_count', e)
                                            }} value={this.state.extra.infant_seat_count}>
                                                <option value="0">0</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="pax">Booster Seat</label>
                                            <select className="form-control" id="pax" onChange={(e) => {
                                                this.handleInputChange('booster_seat_count', e)
                                            }} value={this.state.extra.booster_seat_count}>
                                                <option value="0">0</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                            </select>
                                        </div>
                                        {/* <div className="col-md-3">
                                            <label htmlFor="pax">Waiting Time</label>
                                            <select className="form-control" id="pax" onChange={ (e) => {this.handleInputChange('waiting_time',e)} } value={this.state.extra.waiting_time}>
                                                <option value="0">0 min</option>
                                                <option value="30">30 min</option>
                                                <option> value="60"1 hr</option>
                                                <option value="90">1 hr 30 min</option>
                                            </select>
                                        </div> */}

                                        <div className="col-md-6">
                                            <label htmlFor="pick-address">PickUp address line</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="pick-address"
                                                placeholder="PickUp address line"
                                                value={this.state.extra.pickup_address_line}
                                                onChange={(e) => {
                                                    this.handleInputChange('pickup_address_line', e)
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="drop-address">Dropoff address line</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="drop-address"
                                                placeholder="Dropoff address line"
                                                value={this.state.extra.dropoff_address_line}
                                                onChange={(e) => {
                                                    this.handleInputChange('dropoff_address_line', e)
                                                }}
                                            />
                                        </div>

                                    </div>
                                    {(this.startAddressType === 'airport' || ( this.startAddressType !== 'airport' && this.quote.trip_type === 'round_trip' )) &&
                                    <div>
                                        <h4>Arrival Flight Information</h4>
                                        <div className="row no-gutter">
                                            <div className="col-md-6">
                                                <label htmlFor="airlinename">Airline Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.extra.airline_name}
                                                    onChange={(e) => {
                                                        this.handleInputChange('airline_name', e)
                                                    }}
                                                    id="airlinename"
                                                    placeholder="Enter Airline Name"
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="flighnum">Flight Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.extra.flight_number}
                                                    onChange={(e) => {
                                                        this.handleInputChange('flight_number', e)
                                                    }}
                                                    id="flighnum"
                                                    placeholder="Enter Flight Number"
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="arivaltime">Flight Arrival Time</label>
                                                <DatePicker
                                                    selected={this.state.extra.arrival_time_full}
                                                    onChange={(e) => {
                                                        this.handleInputChange('arrival_time', e)
                                                    }}
                                                    showTimeSelectOnly
                                                    showTimeSelect
                                                    dateFormat="hh:mm aa"
                                                    timeFormat="hh:mm aa"
                                                    placeholderText="Enter Flight Arrival Time"
                                                    timeIntervals={15}
                                                    type="text"
                                                    className="form-control"
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="messgaeboard">
                                                    Name or Message on the pickup sign
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.extra.message_board}
                                                    onChange={(e) => {
                                                        this.handleInputChange('message_board', e)
                                                    }}
                                                    id="messgaeboard"
                                                    placeholder="Name or Message on the pickup sign"
                                                />
                                            </div>
                                        </div>
                                    </div>


                                    }
                                    {this.quote.trip_type === 'round_trip' &&
                                    <div>
                                        <h4>Return Journey Information</h4>
                                        <div className="row no-gutter">
                                            <div className="col-md-6">
                                                <label htmlFor="airlinename">Return Pickup Date</label>
                                                <DatePicker
                                                    required
                                                    selected={this.state.startDate}
                                                    onChange={this.handleDateChange}
                                                    name="startDate"
                                                    dateFormat="MM/dd/yyyy"
                                                    placeholderText="Pickup Date"
                                                    type="text"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    minDate={new Date()}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="flighnum">Return Pickup Time</label>
                                                <DatePicker
                                                    selected={this.state.startTime}
                                                    onChange={this.handleTimeChange}
                                                    showTimeSelectOnly
                                                    showTimeSelect
                                                    dateFormat="HH:mm"
                                                    timeFormat="HH:mm"
                                                    placeholderText="Pickup Time"
                                                    timeIntervals={15}
                                                    type="text"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                    </div>


                                    }
                                    {(this.startAddressType !== 'airport' || ( this.startAddressType === 'airport' && this.quote.trip_type === 'round_trip' )) &&
                                    <div>
                                        <h4>Departure Flight Information</h4>
                                        <div className="row no-gutter">
                                            <div className="col-md-6">
                                                <label htmlFor="airlinename">Airline Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.extra.return_airline_name}
                                                    onChange={(e) => {
                                                        this.handleInputChange('return_airline_name', e)
                                                    }}
                                                    id="airlinename"
                                                    placeholder="Enter Airline Name"
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="flighnum">Flight Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.extra.return_flight_number}
                                                    onChange={(e) => {
                                                        this.handleInputChange('return_flight_number', e)
                                                    }}
                                                    id="flighnum"
                                                    placeholder="Enter Flight Number"
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="arivaltime">Flight Departure Time</label>
                                                <DatePicker
                                                    selected={this.state.extra.return_arrival_time_full}
                                                    onChange={(e) => {
                                                        this.handleInputChange('return_arrival_time', e)
                                                    }}
                                                    showTimeSelectOnly
                                                    showTimeSelect
                                                    dateFormat="hh:mm aa"
                                                    timeFormat="hh:mm aa"
                                                    placeholderText="Enter Flight Arrival Time"
                                                    timeIntervals={15}
                                                    type="text"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                    </div>


                                    }




                                    <h4>Others Information</h4>
                                    <div className="row no-gutter">
                                        <div className="col-md-12 custom-radio">
                                            <label>Payment Method</label>
                                            <br/>
                                            <input type="radio" id="authorize" name="radio-group" required value={'card'} onChange={(e) => {
                                                this.handleInputChange('payment_type', e)
                                            }}/>
                                            <label htmlFor="authorize">Card</label>

                                            <input type="radio" id="paypal" name="radio-group" value={'paypal'} onChange={(e) => {
                                                this.handleInputChange('payment_type', e)
                                            }}/>
                                            <label htmlFor="paypal">Paypal</label>
                                        </div>

                                        <div className="col-md-12">
                                            <label htmlFor="messgae">Special Instructions</label>
                                            <textarea
                                                className="form-control"
                                                rows="4"
                                                id="messgae"
                                                value={this.state.extra.special_instruction}
                                                onChange={(e) => {
                                                    this.handleInputChange('special_instruction', e)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-check custom-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="terms"
                                            name="terms"
                                            required
                                        />
                                        <label className="form-check-label" htmlFor="terms">
                                            I accept the{" "}
                                            <a href="/terms-and-condition" target="_blank">
                                                Terms & Conditions.
                                            </a>
                                        </label>
                                    </div>
                                    <div className="booking-notify">
                                        <p>
                                           Our cancellation policy or any flight arrival changes policy: Customers must notify us at least 3 hours in advance to get a full refund on their booking, and the notification has to be sent to kellystaxi@gmail.com or call or text to 301-332-7577
                                        </p>
                                </div>
                                    <button className="btn mt-4  pl-5 pr-5 pt-3 pb-3 btn-yellow">
                                        Submit
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(Passenger);
